import React from 'react';
import NetworkInfoDashboard from './components/NetworkInfoDashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <NetworkInfoDashboard />
    </div>
  );
}

export default App;